export const state = () => ({
    list: [],
    settings: { enabled: true, note: null },
    loading: false,
    saving: false,
    uploadProgress: 0,
    error: null,
});
